export enum AssignType {
	Automatic = 0,
	Supervisor = 1,
	Claimable = 2,
}
